import { join } from 'light-component';
import { Box } from '../../../box';
import { useTranslation } from '../../../i18n';
import { DragItem, Highlighter } from '../../component';
import styles from '../style.module.less';
import { service } from '../service';
import { RichTextComponent } from './richText';
import type { ReactElement } from 'react';
import type { RichTextProps } from './types';

export function RichTextInputMode(props: RichTextProps): ReactElement {
  const [t] = useTranslation();

  if (props.name == null) {
    return (
      <DragItem title={t('RichText')} />
    );
  }

  return (
    <Box className={styles.inputBox} style={{ marginLeft: service.getIndent(props.path, 0.7) }}>
      <Box className={styles.subject}>
        <Highlighter
          title={props.title}
          keyword={props.keyword}
          className={styles.title}
        />
      </Box>
      <Box className={join(styles.action, styles.input)}>
        <RichTextComponent {...props} />
      </Box>
    </Box>
  );
}
